import { ENDPOINTS, localizedUrl } from '@/helpers'

const baseURL = import.meta.env.VITE_APP_API_URL.replace(/\/$/, '')

const parseBody = async (response) => {
  const text = await response.text()

  try {
    return JSON.parse(text)
  } catch {
    return text
  }
}

const xsrfToken = () => {
  if (typeof document === 'undefined') return null

  const cookie = document.cookie
    .split('; ')
    .find((row) => row.startsWith('XSRF-TOKEN='))
    ?.split('=')[1]

  return cookie ? decodeURIComponent(cookie) : null
}

const request = async (url, options = {}) => {
  const token = xsrfToken()
  const headers = {
    Accept: 'application/json',
    ...(token ? { 'X-XSRF-TOKEN': token } : {}),
    ...options.headers,
  }

  const response = await fetch(`${baseURL}/${localizedUrl(url).replace(/^\//, '')}`, {
    ...options,
    credentials: 'include',
    headers,
  })
  const data = await parseBody(response)

  if (!response.ok) {
    const error = new Error(`Request failed with status ${response.status}`)
    error.response = { status: response.status, data }
    throw error
  }

  return { status: response.status, data }
}

const http = {
  csrf: false,
  async $init() {
    await request(ENDPOINTS.AUTH.CSRF)
    this.csrf = true

    return this.csrf
  },
  $get(url) {
    return request(url)
  },
  $post(url, data) {
    const isFormData = data instanceof FormData

    return request(url, {
      method: 'POST',
      headers: data && !isFormData ? { 'Content-Type': 'application/json' } : {},
      body: data && !isFormData ? JSON.stringify(data) : data,
    })
  },
}

export default http
